import { put, takeLatest, delay } from "redux-saga/effects";
import { getMerchandisingDetailApi } from "store/api/SpecialOfferApi";
import { GET_MERCHANDISING_DETAIL_ACTION } from "../../actions/SpecialOfferPageAction/actionTypes";

import * as specialOfferPageAction from "../../actions/SpecialOfferPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getMerchandisingDetail(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getMerchandisingDetailApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(
				specialOfferPageAction.setMerchandisingDetailAction(res?.data)
			);
		} else {
			yield errorMessage(res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getMerchandisingDetailSaga() {
	yield takeLatest(GET_MERCHANDISING_DETAIL_ACTION, getMerchandisingDetail);
}

export default getMerchandisingDetailSaga;
